import { pageView } from '@reverbdotcom/commons/src/elog';

export default (location) => {
  // Initial pageView (including non-client routed pages) comes from elog_init.js
  pageView(location);

  if (window.ga !== undefined) {
    const urlWithParams = `${location.pathname}${location.search}`;
    window.ga('set', 'page', urlWithParams);
    window.ga('send', 'pageview');
  }
};
